import { THEME } from 'styles/themes';

export const colors = THEME.Footer.colors ?? {};

export const typography = THEME.Footer.typography;

export const options = THEME.Navbar.options ?? {};
